import { render } from "./SideWrapper.vue?vue&type=template&id=71af3268&scoped=true"
import script from "./SideWrapper.vue?vue&type=script&lang=js"
export * from "./SideWrapper.vue?vue&type=script&lang=js"

import "./SideWrapper.vue?vue&type=style&index=0&id=71af3268&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71af3268"]])

export default __exports__